export const getHasPaidPortal = state => state.portalTier.hasPaidPortals;
export const getHasTrialPortal = state => state.portalTier.hasTrialPortals;
export const getHasPaidProducts = state => state.portalTier.hasPaidPortals || state.portalTier.hasTrialPortals;